import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API, withCredentials: true });

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isPublicMenu = window.location.pathname === "/menu" || window.location.pathname.startsWith("/menu/");
      if (window.location.pathname !== "/login" && !isPublicMenu) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const api = {
  auth: {
    sendMagicLink: (email) => apiClient.post("/auth/send-magic-link", { email }),
    verifyOtp: (data) => apiClient.post("/auth/verify-otp", data),
    me: () => apiClient.get("/auth/me"),
    logout: () => apiClient.post("/auth/logout"),
  },
  admin: {
    stats: () => apiClient.get("/admin/stats"),
    getCategories: (menuId) => apiClient.get("/admin/categories", { params: menuId ? { menu_id: menuId } : {} }),
    createCategory: (data) => apiClient.post("/admin/categories", data),
    updateCategory: (id, data) => apiClient.put(`/admin/categories/${id}`, data),
    deleteCategory: (id) => apiClient.delete(`/admin/categories/${id}`),
    reorderCategories: (ids) => apiClient.put("/admin/categories/reorder", { ids }),

    getSubcategories: (categoryId, menuId) => apiClient.get("/admin/subcategories", { params: { ...(categoryId ? { category_id: categoryId } : {}), ...(menuId ? { menu_id: menuId } : {}) } }),
    createSubcategory: (data) => apiClient.post("/admin/subcategories", data),
    updateSubcategory: (id, data) => apiClient.put(`/admin/subcategories/${id}`, data),
    deleteSubcategory: (id) => apiClient.delete(`/admin/subcategories/${id}`),
    reorderSubcategories: (categoryId, ids) => apiClient.put("/admin/subcategories/reorder", { category_id: categoryId, ids }),

    getAvailableCategories: (menuId) => apiClient.get(`/admin/menus/${menuId}/available-categories`),
    linkCategoryToMenu: (menuId, categoryId) => apiClient.post(`/admin/menus/${menuId}/link-category/${categoryId}`),
    unlinkCategoryFromMenu: (menuId, categoryId) => apiClient.delete(`/admin/menus/${menuId}/link-category/${categoryId}`),
    unlinkSubcategoryFromMenu: (menuId, subcategoryId) => apiClient.delete(`/admin/menus/${menuId}/link-subcategory/${subcategoryId}`),
    updateMenuTemplate: (menuId, templateSlug) => apiClient.put(`/admin/menus/${menuId}/template`, { template_slug: templateSlug }),

    getProducts: (params) => apiClient.get("/admin/products", { params }),
    createProduct: (data) => apiClient.post("/admin/products", data),
    updateProduct: (id, data) => apiClient.put(`/admin/products/${id}`, data),
    reorderProducts: (subcategoryId, ids) => apiClient.put("/admin/products/reorder", { subcategory_id: subcategoryId, ids }),
    deleteProduct: (id) => apiClient.delete(`/admin/products/${id}`),

    getMenus: () => apiClient.get("/admin/menus"),
    getPublicMenuSettings: () => apiClient.get("/admin/public-menu-settings"),
    updatePublicMenuSettings: (data) => apiClient.put("/admin/public-menu-settings", data),
    getMenu: (id) => apiClient.get(`/admin/menus/${id}`),
    createMenu: (data) => apiClient.post("/admin/menus", data),
    updateMenu: (id, data) => apiClient.put(`/admin/menus/${id}`, data),
    deleteMenu: (id) => apiClient.delete(`/admin/menus/${id}`),
    getMenuStructure: (id) => apiClient.get(`/admin/menus/${id}/structure`),
    assignProductToMenu: (id, data) => apiClient.post(`/admin/menus/${id}/products`, data),
    updateMenuProduct: (menuId, assignmentId, data) => apiClient.put(`/admin/menus/${menuId}/products/${assignmentId}`, data),
    deleteMenuProduct: (menuId, assignmentId) => apiClient.delete(`/admin/menus/${menuId}/products/${assignmentId}`),
    reorderMenu: (menuId, data) => apiClient.put(`/admin/menus/${menuId}/reorder`, data),

    previewProductImport: (formData) => apiClient.post("/admin/import/products/preview", formData, { headers: { "Content-Type": "multipart/form-data" } }),
    applyProductImport: (data) => apiClient.post("/admin/import/products/apply", data),
    previewMenuImport: (formData) => apiClient.post("/admin/import/menus/preview", formData, { headers: { "Content-Type": "multipart/form-data" } }),
    applyMenuImport: (data) => apiClient.post("/admin/import/menus/apply", data),

    getUsers: (params) => apiClient.get("/admin/users", { params }),
    createUser: (data) => apiClient.post("/admin/users", data),
    toggleUserActive: (id) => apiClient.put(`/admin/users/${id}/toggle-active`),
    deleteUser: (id) => apiClient.delete(`/admin/users/${id}`),

    getSmtp: () => apiClient.get("/admin/smtp"),
    updateSmtp: (data) => apiClient.put("/admin/smtp", data),
    testSmtp: () => apiClient.post("/admin/smtp/test"),
    getTemplates: () => apiClient.get("/admin/templates"),
  },
  public: {
    getMenu: (slug) => apiClient.get(`/public/menus/${slug}`, { params: { v: Date.now() } }),
    getMenuIndex: () => apiClient.get("/public/menu-index"),
  },
  upload: (formData) => apiClient.post("/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }),
};

export default api;